import EwaybillDTO from "@/dto/order/EwaybillDTO";

/**
 * 电子面单包含的商品信息
 */
export interface EwaybillOrderItemInfo {
    originalId: string;

    /**
     * 商品数量，负数表示分数，如-2表示1/2（半个商品），-3表示1/3（三分之一个商品）
     */
    quantity: number;
}

/**
 * 电子面单商品信息解析器
 *
 * 返回电子面单真实包含的商品信息
 */
export class EwaybillOrderItemInfoParser {
    static parse(orderItemInfo: EwaybillDTO["orderItemsInfo"]) {
        if (!orderItemInfo) {
            return [];
        }

        const orderItemInfos: EwaybillOrderItemInfo[] = [];

        const parts = orderItemInfo.split(";");

        for (let i = 0; i < parts.length; i++) {
            const part = parts[i];

            if (!part) {
                continue;
            }

            const keyValuePair = part.split("*");

            if (keyValuePair.length != 2) {
                console.error("can not parse Ewaybill.orderItemInfo: " + orderItemInfo);

                continue;
            }
            const originalId = keyValuePair[0];

            const quantity = parseInt(keyValuePair[1], 10);

            if (Number.isNaN(quantity)) {
                console.error(`can not parse Ewaybill.orderItemInfo: quantity ${keyValuePair[1]} is not a number;`);
                continue;
            }

            orderItemInfos.push({
                originalId,
                quantity,
            });
        }

        return orderItemInfos;
    }
}
